/**
 * `?embed=1`: a partner page framed on the partner's own site (the server lets them, graphql/helpers/partnerFraming.ts).
 * Read from the router's `location.search`, which is the request's on the server (`renderMarketing`) and the address bar's
 * on the client, so the HTML and the hydrating render agree.
 */
export const isEmbed = (search: string): boolean => new URLSearchParams(search).get("embed") === "1";

/** For a link that leaves the framed page: signing in does not work reliably inside a third-party frame, so it opens a tab of its own. */
export const NEW_TAB = { target: "_blank", rel: "noopener" } as const;
